// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import store from './redux/store';
import { ModalProvider } from "./context/ModalContext";
import { ActiveItemProvider } from "./context/ActiveItemContext";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ModalProvider>
      <ActiveItemProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ActiveItemProvider>
    </ModalProvider>
  </Provider>
);
